<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none"
      xmlns="http://www.w3.org/2000/svg">
  <path d="M10 12.7819L5.28848 8.07041L6.0625 7.29639L10 11.2339L13.9375 7.29639L14.7115 8.07041L10 12.7819Z"
        fill="#333333"/>
</svg>
</template>